import Swap from '../views/Swap'

const IndexPage = () => {
  return <Swap />
}

export default IndexPage
